module.exports = __webpack_public_path__ + "img/img_sub_prod_tibco03.1eb23522.svg";